<template>
  <div class="bookings">
    <v-text-field
      label="Поиск по телефону"
      v-model="search"
      filled
      class="search"
      v-mask="'+7 (###) ### ##-##'"
    >
      <v-btn slot="append" color="primary" @click="getByPhone">
        <v-icon left>mdi-magnify</v-icon> искать
      </v-btn>
      <v-btn slot="append" @click="getAll" v-if="search.length > 0">
        <v-icon left>mdi-close</v-icon> очистить
      </v-btn>
    </v-text-field>

    <v-card class="search notif" v-if="searchCode == 'error'">
      <p>Заказ с таким кодом не найдено</p>
    </v-card>
    <v-data-table
      :hide-default-footer="true"
      :items="bookings"
      class="elevation-1 table_releases"
    >
      <template slot="header" :header="headers">
        <thead>
          <tr>
            <th v-for="header in headers" :key="header.text">
              <div class="text">
                {{ header.text }}
              </div>
            </th>
          </tr>
        </thead>
      </template>
      <template v-slot:item="{ item }">
        <tr>
          <td class="text-start">{{ getTime(item.date) }}</td>
          <td class="text-start">{{ item.name }}</td>
          <td class="text-start">{{ item.phone }}</td>
          <td class="text-start length">
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <div v-bind="attrs" v-on="on">{{ item.program }}</div>
              </template>
              <span>{{ item.program }}</span>
            </v-tooltip>
          </td>
          <td class="text-start length">
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <div v-bind="attrs" v-on="on">{{ item.subprogram }}</div>
              </template>
              <span>{{ item.subprogram }}</span>
            </v-tooltip>
          </td>
          <!-- <td class="text-start">
            {{ item.option.length > 5 ? item.option + "мин." : item.option }}
          </td> -->
          <td class="text-start">{{ item.date_booking }}</td>
          <td class="text-start">{{ item.time_booking }}</td>
          <td class="text-start">{{ item.price }}руб.</td>
          <td class="text-start">
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                  v-bind="attrs"
                  v-on="on"
                  :color="item.paid == 'true' ? 'success' : 'error'"
                  >{{
                    item.paid == "true"
                      ? "mdi-checkbox-marked-circle"
                      : "mdi-cancel"
                  }}</v-icon
                >
              </template>
              <span>{{
                item.paid == "true" ? "Оплачено" : "НЕ оплачено"
              }}</span>
            </v-tooltip>
          </td>
          <td>
            <v-btn
              small
              depressed
              color="black"
              class="white--text"
              @click="openMoreInfo(item)"
              >Открыть</v-btn
            >
          </td>
        </tr>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import axios from "axios";

import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";
dayjs.extend(relativeTime);

export default {
  name: "Bookings",
  data: () => ({
    bookings: [],
    headers: [
      {
        text: "Дата оформление",
        sortable: false,
      },
      {
        text: "Имя",
        sortable: false,
      },
      {
        text: "Телефон",
        sortable: false,
      },
      {
        text: "Услуга",
        sortable: false,
      },
      {
        text: "Тип услуги",
        sortable: false,
      },
      // {
      //   text: "Опция",
      //   sortable: false,
      // },
      {
        text: "Дата записи",
        sortable: false,
      },
      {
        text: "Время прихода",
        sortable: false,
      },
      {
        text: "Цена услгуи",
        sortable: false,
      },
      {
        text: "Статус",
        sortable: false,
      },
      {
        text: "Действие",
        sortable: false,
      },
    ],
    search: "",
    searchCode: "",
  }),
  methods: {
    getTime(time) {
      return dayjs(parseInt(time)).format("YYYY-MM-DD/HH:mm");
    },
    getAll() {
      axios
        .get(`${process.env.VUE_APP_AXIOS}/booking/all`, {
          headers: {
            token: localStorage.getItem("token"),
          },
        })
        .then((res) => {
          this.bookings = res.data.bookings;
          // console.log(this.bookings);
        });
    },
    getByPhone() {
      axios
        .get(`${process.env.VUE_APP_AXIOS}/booking/byid`, {
          headers: {
            token: localStorage.getItem("token"),
            phone: this.search,
          },
        })
        .then(
          (res) => {
            this.bookings = [];
            this.bookings.push(res.data.bookings);
          },
          (err) => {
            console.log(err);
          }
        );
    },
    openMoreInfo(order) {
      this.$store.state.more.data = order;
      this.$store.state.more.active = true;
    },
  },
  created() {
    this.getAll();
  },
};
</script>

<style lang="scss" scoped>
.length div {
  width: 250px !important;
  white-space: nowrap !important;
  overflow: hidden !important;
  text-overflow: ellipsis !important;
}
</style>